import { env } from "@/env.setup";

export async function getKey(): Promise<string | undefined> {
  return env.VITE_AWS_PLACES_INDEX_KEY
}
